import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-profile-intro',
    imports: [],
    templateUrl: './mp-profile-intro.component.html',
    styleUrl: './mp-profile-intro.component.scss'
})
export class MpProfileIntroComponent {}